/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.EmaxSimulate <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 27.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.EmaxSimulate", jQuery.common.VisualBase, {
    delDialog: null,
    editDialog: null,
    chartDialog: null,
    selectedId: null,
    duration: null,

    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 347;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
         
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
          
            me.showMessage("", false);
            me.fnd(".caption").css("display", "inline-block").addClass("vc-grid-1col")
            me.fnd("input").addClass("txtEnabled").attr("type", "number").css("text-align", "right").css("width", 60);
         
            me.fnd("#btn-simulate").on("click", function () {
                me._sendTask({ type: 0, mkorr: me.fnd("#txt-mkorr").val(), skorr: me.fnd("#txt-skorr").val(), duration: me.fnd("#txt-time").val() });
            }).button();

            me.fnd("#btn-simulate-digout").on("click", function () {
                me._sendTask({ type: 1, bsdid: me.fnd("#ddl-digout").val(), state: me.fnd("#ddl-type").val(), duration: me.fnd("#txt-time-digout").val() });
            }).button();
          

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () { },


    _sendTask: function (p) {
        var me = this;
        try {
            me.updateData(p, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                } else {
                    alert(me.specific.resources.isDone + "!");
                }
                return true;
            });

        } catch (e) {
            me.writeError('_sendTasks', e);
            return false;
        }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

